import React, { useState } from 'react';
import { CalendarCheck, Camera } from 'lucide-react';
import { PORTAL_URL } from '../SiteLayout';
import { CMT_PHOTOS, CMT_MINI_PHOTOS, photoThumb, miniPhoto } from '../data/photos';
import Lightbox from '../components/Lightbox';
import PageSEO from '../../components/PageSEO';

export default function SiteGallery() {
  const [openIdx, setOpenIdx] = useState(null);

  const next = () => setOpenIdx((i) => (i + 1) % CMT_PHOTOS.length);
  const prev = () => setOpenIdx((i) => (i - 1 + CMT_PHOTOS.length) % CMT_PHOTOS.length);

  return (
    <main data-testid="site-gallery">
      <PageSEO
        title="Galerie photo — Découvrez le CMT à Matadi"
        description="Photos réelles du Centre Médical la Trinité à Matadi : façade, accueil, salle d'attente, cabinets de consultation, échographie, chambres d'hospitalisation, équipe soignante."
        path="/galerie"
      />
      <div className="site-page-head">
        <div className="site-page-head-inner">
          <span className="site-article-cat" style={{ background: 'rgba(255,255,255,0.18)', color: 'white' }}>
            <Camera size={13} style={{ marginRight: 6, verticalAlign: -2 }} />
            Galerie photo
          </span>
          <h1 className="site-reveal" style={{ marginTop: '.8rem' }}>Découvrez le Centre Médical la Trinité</h1>
          <p className="site-reveal-1">
            Des locaux modernes, une équipe engagée, des équipements de qualité —
            découvrez en images notre centre à Matadi.
          </p>
        </div>
      </div>

      <section className="site-section">
        <div className="cmt-gallery-grid" data-testid="cmt-gallery-grid">
          {CMT_PHOTOS.map((p, i) => (
            <button
              type="button"
              key={p.file}
              className="cmt-gallery-item"
              onClick={() => setOpenIdx(i)}
              data-testid={`gallery-item-${p.file}`}
              aria-label={p.caption}
            >
              <img src={photoThumb(p.file)} alt={p.caption} loading="lazy" />
              <span className="cmt-gallery-caption">{p.caption}</span>
            </button>
          ))}
        </div>

        {/* Moments d'équipe — petit format, non zoomables */}
        <div style={{ marginTop: '3rem' }}>
          <span className="site-kicker">Moments d&apos;équipe</span>
          <h2 style={{ marginBottom: '.4rem' }}>Instantanés capturés au CMT</h2>
          <p className="site-section-sub">Quelques moments de la vie du centre — archives d&apos;équipe.</p>
          <div className="cmt-mini-grid" data-testid="cmt-mini-grid">
            {CMT_MINI_PHOTOS.map((p) => (
              <figure key={p.file} className="cmt-mini-tile">
                <img src={miniPhoto(p.file)} alt={p.caption} loading="lazy" />
                <figcaption>{p.caption}</figcaption>
              </figure>
            ))}
          </div>
        </div>

        <div className="site-cta-band" style={{ marginTop: '3rem' }}>
          <div>
            <h2>Envie de nous rencontrer ?</h2>
            <p>Prenez rendez-vous en quelques clics et venez découvrir nos locaux par vous-même.</p>
          </div>
          <a href={`${PORTAL_URL}?page=booking`} className="site-btn site-btn-outline" style={{ background: 'white' }} data-testid="gallery-cta-booking-btn">
            <CalendarCheck size={18} /> Prendre rendez-vous
          </a>
        </div>
      </section>

      {openIdx !== null && (
        <Lightbox
          photos={CMT_PHOTOS}
          index={openIdx}
          onClose={() => setOpenIdx(null)}
          onNext={next}
          onPrev={prev}
        />
      )}
    </main>
  );
}
